import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import { store } from "../../store";
export default function* watcherAddStorageTankSaga() {
  yield takeEvery("ADD_STORAGE_TANK", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER" });
    let payload = {};
    yield request("post", action.payload, "/add-storage-tank").then(
      (response) => {
        payload = response;
      }
    );
    toast.success(payload);
    var formatUrl = "/get-storage-tanks";
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "STORAGE_TANKS_LIST", payload: payload });

    yield put({ type: "DISPLAY_LOADER" });
  } catch (e) {
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    console.log("add-storage-tank-saga", e);
    yield put({ type: "DISPLAY_LOADER" });
    console.log("add-storage-tank-saga", e.response);
    console.log(e.response);
    console.log(e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
